module.exports = __webpack_public_path__ + "assets/images/EUR001.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR001.png
// module id = 1356
// module chunks = 1